import { arrayToObjectCovert } from '../../../../services/commonService';

const handleFetchTimeRequestsFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.timeRequests = arrayToObjectCovert(action.payload.data);
  state.timeRequestsOrder = action.payload.data.map(request => request.id);
  state.currentPage = action.payload.current_page;
  state.perPage = action.payload.limit;
  state.totalPages = action.payload.total_pages;
  state.totalTimeRequests = action.payload.total_count;
  state.lastUpdated = action.payload.last_updated;
  state.message = action.payload.message;
};

const handleDeleteTimeRequestFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.timeRequests = state.timeRequests.filter(timeRequest => timeRequest.id !== action.payload.data);
  state.message = action.payload.message;
};

const handleAddTimeRequestFulfilled = (state, action) => {
  state.status = 'succeeded';
  const timeRequestId = action.payload.data.id;
  if (!state.timeRequests[timeRequestId]) {
    state.timeRequests[timeRequestId] = [];
  }
  state.timeRequests[timeRequestId].push(action.payload.data);
  state.message = action.payload.message;
};

const handleFetchTimeRequestByIdFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.currentTimeRequest = action.payload.data;
};

const handleUpdateTimeRequestFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.timeRequests[action.payload.data.id] = action.payload.data;
  state.currentTimeRequest = action.payload.data;
  state.message = action.payload.message;
};

const handleFetchManagerApprovedTimeRequestFulfilled = (state, action) => {
  state.managerApprovedTimeRequestStatus = 'succeeded';
  state.managerApprovedTimeRequest = action.payload.data;
  state.managerApprovedTimeRequestOrder = action.payload.data.map(request => request.id);
  state.managerApprovedTimeRequestCurrentPage = action.payload.current_page;
  state.managerApprovedTimeRequestPerPage = action.payload.limit;
  state.managerApprovedTimeRequestTotalPages = action.payload.total_pages;
  state.managerApprovedTimeRequestTotal = action.payload.total_count;
  state.managerApprovedTimeRequestLastUpdated = action.payload.last_updated;
  state.managerApprovedTimeRequestMessage = action.payload.message;
};

const handleAddManagerApprovedTimeRequestFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.message = action.payload.message;
};

const handleFetchManagerApprovedTimeRequestByIdFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.currentManagerApprovedTimeRequest = action.payload.data;
};

const handleFetchReportTimeRequestHistoryFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.reportTimeRequestHistory = arrayToObjectCovert(action.payload.data);
  state.reportTimeRequestHistoryOrder = action.payload.data.map(request => request.id);
  state.reportTimeRequestHistoryCurrentPage = action.payload.current_page;
  state.reportTimeRequestHistoryPerPage = action.payload.limit;
  state.reportTimeRequestHistoryTotalPages = action.payload.total_pages;
  state.reportTimeRequestHistoryTotal = action.payload.total_count;
  state.reportTimeRequestHistoryLastUpdated = action.payload.last_updated;
  state.message = action.payload.message;
};

const handleFetchReportTimeEntryFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.reportTimeEntry = action.payload.data;
  state.reportTimeEntryCurrentPage = action.payload.current_page;
  state.reportTimeEntryPerPage = action.payload.limit;
  state.reportTimeEntryTotalPages = action.payload.total_pages;
  state.reportTimeEntryTotal = action.payload.total_count;
  state.reportTimeEntryLastUpdated = action.payload.last_updated;
  state.message = action.payload.message;
};


const handleWithdrawTimeRequestFulfilled = (state, action) => {
  state.status = 'succeeded';
  state.timeRequests[action.payload.time_request_apply_id] = action.payload.data;
  state.message = action.payload.message;
};

const handleFetchReporteesTimeRequestsFulfilled = (state, action) => {
  state.reporteesTimeRequestStatus = 'succeeded';
  state.reporteesTimeRequest = arrayToObjectCovert(action.payload.data);
  state.reporteesTimeRequestOrder = action.payload.data.map(request => request.id);
  state.reporteesTimeRequestCurrentPage = action.payload.current_page;
  state.reporteesTimeRequestPerPage = action.payload.limit;
  state.reporteesTimeRequestTotalPage = action.payload.total_pages;
  state.reporteesTimeRequestTotal = action.payload.total_count;
  state.reporteesTimeRequestLastUpdated = action.payload.last_updated;
  state.reporteesTimeRequestMessage = action.payload.message;
};


const handleUpdateReporteesTimeRequestActionFulfilled = (state, action) => {
  state.reporteesTimeRequestStatus = 'succeeded';
  state.reporteesTimeRequest[action.payload.id] = action.payload;
  state.reporteesTimeRequestMessage = action.payload.message;
};

export {
  handleFetchTimeRequestsFulfilled,
  handleDeleteTimeRequestFulfilled,
  handleAddTimeRequestFulfilled,
  handleFetchTimeRequestByIdFulfilled,
  handleUpdateTimeRequestFulfilled,
  handleFetchManagerApprovedTimeRequestFulfilled,
  handleFetchReportTimeRequestHistoryFulfilled,
  handleAddManagerApprovedTimeRequestFulfilled,
  handleFetchManagerApprovedTimeRequestByIdFulfilled,
  handleWithdrawTimeRequestFulfilled,
  handleFetchReporteesTimeRequestsFulfilled,
  handleUpdateReporteesTimeRequestActionFulfilled,
  handleFetchReportTimeEntryFulfilled,
};
